import { Component, OnInit } from '@angular/core';
import { environment as params, environment } from 'src/environments/environment';

declare var $:any;

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  urlBaseMJ: any = (<any>params).api.mj;

  constructor() { }

  ngOnInit() {
  }

  // Scroll TOP
  ngAfterViewInit() {
    $(document).ready(function () {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
  }

}
